/** Save/Restore are refused when the PDF Templates API predates PDF-1: it ignores `asDraft` and would publish. */
export const STALE_DRAFT_API_MESSAGE = 'Saving drafts needs an updated PDF Templates API.';

/** The API answered a draft write with a Published version: the edits are saved AND live, never "not saved". */
export const SAVED_AND_PUBLISHED_MESSAGE = 'Saved and published (the server does not support drafts)';

/** Shown under the block name when it is empty (BE-17); Save and Publish stay off until it is filled in. */
export const BLOCK_NAME_REQUIRED_MESSAGE = 'Block name is required.';

/** Publish is refused up front when a prose block (e.g. Terms) has no body text: the API would reject it (LLAMS-686). */
export const PROSE_BODY_REQUIRED_MESSAGE = 'Add body text before publishing this block.';

/** New block's Publish was refused (400) because the default content has nothing renderable yet: the block exists as a Draft. */
export const NEW_BLOCK_DRAFT_NO_CONTENT_MESSAGE =
  'Block created as a draft. It has no content to publish yet - add content and publish it from the editor.';

/** New block's Publish failed for another reason (network, server): the block exists as a Draft and Publish can be retried there. */
export const NEW_BLOCK_DRAFT_PUBLISH_FAILED_MESSAGE = 'Block created as a draft, but it could not be published. Try again from the editor.';
